import { isAxiosError } from './is-axios-error';
/**
 *
 * Evaluate if the provided error is an AxiosError containing a Glovo API
 * error response (TypeGuard)
 *
 */
export function isApiError(error) {
    if (!isAxiosError(error)) {
        return false;
    }
    const { data } = error.response ?? {};
    return typeof data === 'object' && !!data && 'error' in data;
}
//# sourceMappingURL=is-api-error.js.map